import axios from './axios'



// 查询当前用户的权限
export function selectUser(){
    return axios.get(`sys/selectUser`)  
}

// 商品列表
export function commodityList(data){
    return axios.post(`commodity/listPage`,data)  
}

// 新增商品
export function save(data){
    return axios.post(`commodity/save`,data)
}
// 编辑回显
export function getCommodityInfo(params){
    return axios.get(`commodity/info/${params}`)
}
// 更新商品信息
export function update(data){
    return axios.post(`commodity/update`,data)
}
// 删除商品
export function handlerDelete(data){
    return axios.post(`commodity/delete`,data)
}

// 查询商品分类

export function sort(){
    return axios.get(`commodityType/queryType`)
}
// 查询商品单位

export function unit(){
    return axios.get(`commodityType/list`)
}